import { render } from "./YoutubeVideoIdInput.vue?vue&type=template&id=09faa924&scoped=true"
import script from "./YoutubeVideoIdInput.vue?vue&type=script&lang=js"
export * from "./YoutubeVideoIdInput.vue?vue&type=script&lang=js"

import "./YoutubeVideoIdInput.vue?vue&type=style&index=0&id=09faa924&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09faa924"]])

export default __exports__